import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

/** Name search / id lookup over suppliers, for vendor pickers and filters. */
export function useSupplierSearch(
  input: { search?: string; ids?: string[]; limit?: number },
  options?: { enabled?: boolean },
) {
  return useQuery({
    ...orpc.accountsPayable.suppliers.search.queryOptions({ input }),
    enabled: options?.enabled ?? true,
    placeholderData: (previous) => previous,
  });
}
